import { SimplePageLayout, SimplePageContentWrapper } from '@flexinet/ui-components';
import { PersonasPageHeader } from '../components/PersonasPageHeader';
import { PersonasPageNavigation } from '../navigation/PersonasPageNavigation';
import { PersonasTable } from '../tables/PersonasTable';

export const PersonasOverviewPage = () => {
    return (
        <SimplePageLayout
            pageHeader={<PersonasPageHeader />}
            pageNavigation={<PersonasPageNavigation />}
        >
            <SimplePageContentWrapper>
                <PersonasTable />
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
